import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { environment } from "../../environments/environment";
import { AppState } from "../models/app-state.model";

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  private pageInitSource = new Subject();
  public pageInit$ = this.pageInitSource.asObservable();
  private baseUrl = `${environment.datalabUrl}appState`;
  constructor(private http: HttpClient) { }

  public initPage(): void {
    this.pageInitSource.next(null);
  }

  public getState(): Observable<AppState> {
    let headers = new HttpHeaders();
    headers = headers.set('x-skip-error-handler', 'true');
    
    return this.http.get<AppState>(this.baseUrl, { headers });
  }
}